import gql from 'graphql-tag';

export const ORGANIZER_FRAGMENT = gql`
  fragment organizer on OrganizerType {
    id
    name
    createdAt
    informations
    profileImage
    website
    phone
    facebookUrl
    instagramUrl
    twitterUrl
    youtubeUrl
    crowdfundingUrl
  }
`;
